<template>
  <v-container>
    <h1>Ingresos</h1>
    <v-row class="ma-0">
      <v-col class="d-flex pl-0 py-0">
        <div style="width: 286px;">
          <v-text-field
            v-model="busqueda"
            placeholder="Buscar"
            clearable
            hide-details
            outlined
            style="width: 300px; font-family: 'montserrat-medium'; border-radius: 20px;"
            prepend-inner-icon="mdi-magnify"
          />
        </div>
        <div style="width: 286px;">
          <v-autocomplete
            :label="'Selecciona una currency'"
            :items="currencies"
            hide-details
            style="font-family: 'montserrat-medium'; border-radius: 20px;"
            outlined
            class="ml-2"
            color="black"
            item-value="sValue"
            item-text="sName"
            @change="getIncomes()"
            v-model="selectedCurrency"
          ></v-autocomplete>
        </div>
      </v-col>
      <v-col class="pa-0 my-4 ml-3">
      </v-col>
      <v-col class="d-flex justify-end pa-0 my-4" style="align-items: center;">
        <v-btn color="black" elevation="8" class="white--text ml-4" style="border-radius: 36px; border: 2px solid #000000; font-family: 'montserrat-semibold'; text-transform: none;" @click="dataXLSXIncomes()">
          <v-img class="mr-2" src="../../assets/icons/Vector.svg" style="width: 14px;"></v-img>
          {{ "Descargar" }}
        </v-btn>
      </v-col>
    </v-row>
    <v-skeleton-loader type="table" v-if="isLoading" />
    <v-data-table class="d-none d-sm-block" v-else :items-per-page="10" hide-default-header :items="filteredIncomes" style="background-color: white !important">
      <template v-slot:header="{ props }">
        <thead style="background-color: #f9fafd;">
          <tr>
            <th class="header__title left">{{ "Id" }}</th>  
            <th class="header__title center">{{ 'Payer name' }}</th>
            <th class="header__title center">{{ 'Fecha de ingreso' }}</th>
            <th class="header__title right">{{ 'Monto' }}</th> 
          </tr>
        </thead>
      </template>
      <template v-slot:body="{ items }">
        <tbody style="background: #f9fafd;">
          <tr v-for="item in items" :key="item.id">
            <td class="table__item">{{ item.iTrackingId }}</td>
            <td class="table__item">{{ item.sPayerName ? item.sPayerName : "-" }}</td>
            <td class="table__item">{{ formatDate(item.created_at) }}</td>
            <td class="table__item">{{ formatMoney(item.dAmount) + " " + item.sCurrency }} </td>
          </tr>
        </tbody>
      </template>
    </v-data-table>
  </v-container>
</template>
<script>
  import * as XLSX from "xlsx";
  import { saveAs } from "file-saver";
  import moment from "moment";
  export default {
    name: "Ingresos",
    props: {
      activeTab: String,
      permissionList: Array,
      enterprise: Object
    },
    data() {
      return {
        incomesRaw: [],
        busqueda: "",
        isLoading: true,
        dialogRequestPayment: false,
        forward: null,
        selectedCurrency: "USD",
        currencies: [
          { sName: "USD", sValue: "USD" },
          { sName: "MXN", sValue: "MXN" },
        ],
      };
    },
    watch: {
      activeTab(val) {
        if (val === 'ingresos') {
          this.getIncomes();
        }
      }
    },
    computed: {
      filteredIncomes() {
        if (!this.busqueda) return this.incomesRaw;

        const filtro = this.busqueda.toLowerCase();

        return this.incomesRaw.filter((item) => {
          const fecha = this.formatDate(item.created_at).toLowerCase();
          const nombrePagador = item.sPayerName?.toLowerCase() || '-';
          const monto = `${this.formatMoney(item.dAmount)}`.toLowerCase();

          return (
            String(item.iTrackingId).toLowerCase().includes(filtro) ||
            nombrePagador.includes(filtro) ||
            fecha.includes(filtro) ||
            monto.includes(filtro)
          );
        });
      }
    },
    mounted() {
      if (this.activeTab === 'ingresos') {
        this.getIncomes();
      }
    },
    methods: {
      getIncomes() {
        this.isLoading = true;
        this.incomesRaw = [];
        const payload = {
          sEnterpriseId: this.$route.params.sEnterpriseId,
          currency: this.selectedCurrency
        };

        DB.post(`${URI}/api/v1/en/administrator/fetchIncomes`, payload, {
          headers: {
            Authorization: this.$store.state.sToken
              ? `Bearer ${this.$store.state.sToken}`
              : ""
          }
        })
        .then((response) => {
          this.incomesRaw = response.data.incomes;
          this.isLoading = false;
        }).catch((error) => {
          if (error.response.data.code) {
            this.$router.push("/welcome").catch(() => {});
          }
          this.mixError(error.response.data.message, error.response.status);
        });
      },
      formatMoney(value) {
        let multiplied = value * 100;
        let rounded = Math.round(multiplied);
        let formattedNumber = rounded / 100;
        // Si el valor es -0, lo convertimos a 0
        if (Object.is(formattedNumber, -0)) {
          formattedNumber = 0;
        }
        return new Intl.NumberFormat("en-US", {
          style: "decimal",
          minimumFractionDigits: 2,
          maximumFractionDigits: 2
        }).format(formattedNumber);
      },
      formatDate: function (date) {
        if (this.selectLanguage === "sp") {
          moment.locale("es");
        } else {
          moment.locale("en");
        }
        let newDate = moment(date);
        let formattedDate = newDate.format("MMMM DD, YYYY HH:mm a");
        return formattedDate;
      },
      dataXLSXIncomes() {
        try {
          const data = this.incomesRaw.map((item) => ({
            "ID de seguimiento": item.iTrackingId || "-",
            "Nombre del pagador": item.sPayerName || "-",
            "Fecha de ingreso": item.created_at ? this.formatDate(item.created_at) : "-",
            "Monto": `${this.formatMoney(item.dAmount)}`,
            "Moneda": item.sCurrency || "-"
          }));

          const worksheet = XLSX.utils.json_to_sheet(data);
          const workbook = XLSX.utils.book_new();
          XLSX.utils.book_append_sheet(workbook, worksheet, "Ingresos");

          const excelBuffer = XLSX.write(workbook, { bookType: "xlsx", type: "array" });
          const blob = new Blob([excelBuffer], {
            type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
          });

          saveAs(blob, "Ingresos.xlsx");

          this.success = true;
          this.msgSuccess = "Descargando ingresos";
        } catch (error) {
          console.error("Error al generar XLSX de ingresos:", error);
          this.error = true;
          this.codeError = "XLSX_INCOMES_FAILED";
        }
      }
    }
  };
</script>
<style scoped>
</style>